import React, { useState } from "react";
import { useHubx } from "../../HubX";
import { useHistory, useParams } from "react-router-dom";
import { DO_RESET_TOKEN_VALIDATE } from "../../Fedx";
import { useSnackbar } from "notistack";
import AcceptRegisterTermPage from "../../screens/AcceptRegisterTermPage";
import useConstructor from "../../core/hooks/useConstructor";
import { decodeStringFromBase64 } from "../../helpers/utility";

function AcceptRegisterTerm() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const hub = useHubx();
  const toastr = useSnackbar();
  const { token } = useParams();

  const doReset = async () => {
    try {
      setLoading(true);
      redirectReset();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("doLogin -> error", error);
      toastr.enqueueSnackbar(error.data, {
        variant: "error",
      });
    }
    setLoading(false);
  };

  useConstructor(async () => {
    try {
      const tokenCoding = decodeStringFromBase64(token);

      await hub.request(DO_RESET_TOKEN_VALIDATE, tokenCoding.substr(11));
      hub.notify("is_new_access", true);
      // do stuff
    } catch (error) {
      toastr.enqueueSnackbar(error.data, {
        variant: "error",
      });

      redirect();
    }
  });

  const doCancel = async () => {
    redirect();
  };

  const redirect = () => {
    history.push("/");
  };

  const redirectReset = () => {
    history.push("/reset/" + token);
  };

  return <AcceptRegisterTermPage loading={loading} onSubmit={doReset} onCancel={doCancel} />;
}

export default AcceptRegisterTerm;
